// Conditional-visibility helpers for the Enterprise questionnaire: the shared rules in
// ./questionVisibility.js bound to OrganizationQuestion's id and order fields.
// Semantics must stay in lockstep with backend/Services/ConditionalQuestionRules.cs.

import { createQuestionVisibility } from './questionVisibility';

const v = createQuestionVisibility({ idField: 'organizationQuestionId', orderField: 'questionOrder' });

export const {
    buildQuestionMap,
    isQuestionVisible,
    orderQuestionsWithChildren,
    inheritRootCategory,
    getVisibleQuestions,
    collectDescendantAnswersToClear,
    collectDescendantIds,
} = v;
